import { apolloCallAPI } from '@/public/functions';



export const apolloScheduleAMeeting = (currentForm, formData) => {
    if ($('button', currentForm).hasClass('add-apollo-meeting')) {
        console.log('execute apollo meeting method 02');
        window.ApolloMeetings.submit({
            onRouted: (result) => {
                if (result.success) {
                    console.log('schedule a meeting: ', formData);
                    apolloCallAPI('POST', formData, '/wp-content/plugins/wp-ooma-mkto-api/server-side/apollo/schedule-a-meeting.php');
                } else {
                    // routing failure, see error in result.error
                    const error = result.error;
                    console.log('something wrong: ' + error);
                }
            }

        });

    }

}